export function safeText(val, fallback = "—") {
  if (val === null || val === undefined || val === "") return fallback;
  if (typeof val === "string" || typeof val === "number") return String(val);
  if (typeof val === "object") {
    if (typeof val.name === "string") return val.name;
    if (typeof val.label === "string") return val.label;
    if (typeof val.title === "string") return val.title;
    if (typeof val.firmName === "string") return val.firmName;
    if (typeof val.designationName === "string") return val.designationName;
    if (typeof val.departmentName === "string") return val.departmentName;
    if (typeof val.roleName === "string") return val.roleName;
    if (val.name && typeof val.name === "object") return safeText(val.name, fallback);
    return fallback;
  }
  return fallback;
}

